import { render } from "./PasswordInput.vue?vue&type=template&id=99cbb86e"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"
script.render = render

export default script